import React, {useState, useEffect} from "react";
import Confetti from 'react-dom-confetti';
import { Row, Col, Button, Container } from "react-bootstrap";

export default function Complete(props) {
  let chevronRight = require("images/onboarding/chevronRight.png");
  chevronRight = <img style={{paddingBottom:"3px", paddingLeft:"12px"}} src={`/datapulse${chevronRight}`} />;


  useEffect(() => {
  props.setConfettiTrigger(false)
  setTimeout(() => props.setConfettiTrigger(true), 400)


  }, [])


  props.pageLocator();
  let small = require("images/onboarding/small-blue-circle.png");
  small = <img className="" src={`/datapulse${small}`} />;
  let medium = require("images/onboarding/medium-circle.png");
  medium = <img className="" src={`/datapulse${medium}`} />;
  large;
  let large = require("images/onboarding/large-circle.png");
  large = <img className="" src={`/datapulse${large}`} />;
  return (
    <>
    <Container fluid className="px-lg-5 px-0 transparent">
      <div className="large-circle">{large}</div>
      <div className="medium-circle">{medium}</div>
      <div className="small-circle">{small}</div>
      <Row className="px-lg-4 px-0 mb-3 pb-3 justify-content-center">
        <Col md={10}>
          <div>
            <p className="pb-3 f28 visby-bold light-primary text-center">Victory belongs to the most persevering.</p>
          </div>
          <div>
            <p className=" f16 nunito-regular text-center mb-3 light-primary ">
              Congratulations on completing onboarding for {props.company_name}!{" "}
              </p>
            <p className="visby-bold text-center f24">Well Done!</p>
          </div>
        </Col>
      </Row>
      <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
      <Row className="mt-5 justify-content-center">
        <Col>
          <div className="navButtonRow">
            {props.ppcEnabled ? (
              <Button
                onClick={() => props.submitForm("/datapulse/ppc-dashboard")}
                style={{
                  backgroundColor: "#3291C1",

                  paddingLeft: "55px",
                  paddingRight: "55px",
                }}
                className="py-1 f16 nunito-regular onboarding-completed"
                size="md">
                {`Go to My Dashboard`}{chevronRight}
              </Button>
            ) : (
              <Button
                onClick={() => props.submitForm("/datapulse/seo-dashboard")}
                style={{
                  backgroundColor: "#3291C1",

                  paddingLeft: "55px",
                  paddingRight: "55px",
                }}
                className="py-1 f16 nunito-regular onboarding-completed"
                size="md">
                {`Go to My Dashboard`}{chevronRight}
              </Button>
            )}
          </div>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md={3}>
        {/* <div style={{marginTop: "50vh", zIndex: "10100"}}>
         <Confetti active={ confettiTrigger } config={ config }/>
        </div> */}
        </Col>
      </Row>
    </Container>
    </>
  );
}
